import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const NewsletterSection = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const subscribe = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/subscribe", { email });
            toast.success("You're on the list — welcome to the studio");
            setEmail("");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <section data-testid="newsletter-section" className="bg-espresso text-sand">
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="grid grid-cols-1 gap-10 md:grid-cols-12"
                >
                    <div className="md:col-span-7">
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-sand/50">Letters from the studio</p>
                        <h2 className="mt-5 font-serif text-3xl font-light tracking-tight text-gold md:text-4xl">
                            First dibs on <span className="italic text-sand">new drops.</span>
                        </h2>
                        <p className="mt-5 max-w-md text-base leading-relaxed text-sand/70">
                            Every piece is one of one — when it's gone, it's gone. Join the list and hear about new bags, jewelry, and home goods before anyone else.
                        </p>
                    </div>
                    <form onSubmit={subscribe} className="flex flex-col justify-center md:col-span-5" data-testid="newsletter-form">
                        <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-sand/50" htmlFor="newsletter-email">Your email</label>
                        <div className="mt-3 flex border border-sand/30">
                            <input
                                id="newsletter-email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="newsletter-email-input"
                                placeholder="you@example.com"
                                className="w-full bg-transparent px-4 py-4 text-sm text-sand outline-none placeholder:text-sand/30"
                            />
                            <button
                                type="submit"
                                disabled={loading}
                                data-testid="newsletter-subscribe-button"
                                className="group flex shrink-0 items-center gap-2 bg-gold px-6 font-mono text-xs uppercase tracking-[0.2em] text-espresso transition-colors duration-300 hover:bg-sand disabled:opacity-60"
                            >
                                {loading ? "Joining…" : "Join"}
                                <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                            </button>
                        </div>
                        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-sand/40">No spam — just new pieces, occasionally</p>
                    </form>
                </motion.div>
            </div>
        </section>
    );
};
